module.exports = __webpack_public_path__ + "img/pre_top.7499c089.png";